import Apportionments from './Apportionments';
import Billing from './Billing';
import Brag from './Brag';
import Calculations from './Calculations';
import Entities from './Entities';
import ExchangeRates from './ExchangeRates';
import Extract from './Extract';
import Global from './Global';
import Groups from './Groups';
import Invoices from './Invoices';
import Login from './Login';
import Navigation from './Navigation';
import Onboarding from './Onboarding';
import Postings from './Postings';
import Rules from './Rules';
import Signup from './Signup';
import Team from './Team';
import Transactions from './Transactions';
import Settings from './Settings';
import Sources from './Sources';
import Loans from './Loans';
import Notifications from './Notifications';
import Maintenance from './Maintenance';

// TODO: Improve the exports from individual translation files s we don't have these duplicated keys
const Translations = {
  Apportionments: Apportionments.Apportionments,
  Billing: Billing.Billing,
  Brag: Brag.Brag,
  Calculations: Calculations.Calculations,
  Entities: Entities.Entities,
  ExchangeRates: ExchangeRates.ExchangeRates,
  Extract: Extract.Extract,
  Global: Global.Global,
  Groups: Groups.Groups,
  Invoices: Invoices.Invoices,
  Login: Login.Login,
  Navigation: Navigation.Navigation,
  Onboarding: Onboarding.Onboarding,
  Postings: Postings.Postings,
  Rules: Rules.Rules,
  Signup: Signup.Signup,
  Team: Team.Team,
  Transactions: Transactions.Transactions,
  Settings: Settings.Settings,
  Sources: Sources.Sources,
  Loans: Loans.Loans,
  Notifications: Notifications.Notifications,
  Maintenance: Maintenance.Maintenance,
};

export { Translations };
